import type {
  ListProjectTendersQuery,
  ListProjectTendersResponse,
  ProjectTenderResponse,
  TenderRatesResponse,
  UpdateProjectTenderRequest,
  UpdateTenderRatesRequest,
} from '@kreart/shared';
import { api } from '@/lib/api';

/** Defaults are left out so the URL — and with it the query key — stays stable. */
function serialiseTendersQuery(query: ListProjectTendersQuery): string {
  const p = new URLSearchParams();
  if (query.page !== 1) p.set('page', String(query.page));
  if (query.pageSize !== 10) p.set('pageSize', String(query.pageSize));
  if (query.search) p.set('search', query.search);
  const qs = p.toString();
  return qs ? `?${qs}` : '';
}

export const projectOrganizationApi = {
  getRates: () => api.get<TenderRatesResponse>('/project-organization/rates'),
  updateRates: (body: UpdateTenderRatesRequest) =>
    api.patch<TenderRatesResponse>('/project-organization/rates', body),
  listTenders: (query: ListProjectTendersQuery) =>
    api.get<ListProjectTendersResponse>(
      `/project-organization/tenders${serialiseTendersQuery(query)}`,
    ),
  getTender: (projectId: string) =>
    api.get<ProjectTenderResponse>(`/project-organization/projects/${projectId}/tender`),
  updateTender: (projectId: string, body: UpdateProjectTenderRequest) =>
    api.patch<ProjectTenderResponse>(`/project-organization/projects/${projectId}/tender`, body),
};
